export abstract class EconomyConfig {
    public static readonly houseTxFeePercentNormalized = 0.035;
    public static readonly houseEarningFeePercentNormalized = 0.15;
}
